import { render, staticRenderFns } from "./SignUpOtpScreen.vue?vue&type=template&id=7a4f60f3&scoped=true"
import script from "./SignUpOtpScreen.vue?vue&type=script&lang=js"
export * from "./SignUpOtpScreen.vue?vue&type=script&lang=js"
import style0 from "./SignUpOtpScreen.vue?vue&type=style&index=0&id=7a4f60f3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a4f60f3",
  null
  
)

export default component.exports